module.exports = __webpack_public_path__ + "static/media/icon_channels_whatsapp.d3cdfb91.svg";